import React from 'react';

const CallFormModal = ({
  open,
  form,
  setForm,
  onClose,
  onSubmit,
  submitting = false
}) => {
  if (!open) return null;

  const isEdit = Boolean(form?.id);

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-3">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] shadow-xl border border-slate-200 overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 shrink-0 bg-white">
          <div>
            <h3 className="text-base font-semibold text-slate-900">{isEdit ? 'Edit Call' : 'Create Call'}</h3>
            <p className="text-[11px] text-slate-500">
              {isEdit ? 'Update the call details' : 'Add call details and the next follow-up'}
            </p>
          </div>
          <button type="button" onClick={onClose} className="h-8 w-8 rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50">
            <i className="bi bi-x"></i>
          </button>
        </div>
        <form onSubmit={onSubmit} className="flex-1 min-h-0 flex flex-col">
          <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Name</label>
              <input
                type="text"
                required
                placeholder="Enter name"
                value={form?.name || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Business Name</label>
              <input
                type="text"
                placeholder="Enter business name"
                value={form?.businessName || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, businessName: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Phone</label>
              <input
                type="text"
                required
                placeholder="Enter phone"
                value={form?.phone || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, phone: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Email</label>
              <input
                type="email"
                placeholder="Enter email"
                value={form?.email || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              />
            </div>
          </div>
          <div>
            <label className="block text-[11px] font-semibold text-slate-600 mb-1">Call Type</label>
            <select
              value={form?.callType || 'outgoing'}
              onChange={(e) => setForm((prev) => ({ ...prev, callType: e.target.value }))}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
            >
              <option value="outgoing">Outgoing Call</option>
              <option value="incoming">Incoming Call</option>
            </select>
          </div>

          {!isEdit && (
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-3">
              <p className="text-[11px] font-semibold text-slate-600 mb-2">Follow-up Details</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-slate-600 mb-1">Call Status</label>
                  <select
                    value={form?.callStatus || ''}
                    onChange={(e) => setForm((prev) => ({ ...prev, callStatus: e.target.value }))}
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
                  >
                    <option value="">Select call status</option>
                    <option value="answered">Answered</option>
                    <option value="missed">Missed</option>
                    <option value="busy">Busy</option>
                    <option value="not_connected">Not Connected</option>
                    <option value="invalid">Invalid Number</option>
                    <option value="disconnected">Disconnected</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-slate-600 mb-1">Call Outcome</label>
                  <select
                    value={form?.followUpOutcome || ''}
                    onChange={(e) => setForm((prev) => ({ ...prev, followUpOutcome: e.target.value }))}
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
                  >
                    <option value="">Select call outcome</option>
                    <option value="interested">Interested</option>
                    <option value="not_interested">Not Interested</option>
                    <option value="callback">Callback</option>
                    <option value="no_answer">No Answer</option>
                  </select>
                </div>
              </div>
              {form?.followUpOutcome === 'callback' && (
                <div>
                  <label className="block text-[11px] font-semibold text-slate-600 mb-1">Next Follow-up Date & Time *</label>
                  <input
                    type="datetime-local"
                    required
                    value={form?.nextFollowDateTime || ''}
                    onChange={(e) => setForm((prev) => ({ ...prev, nextFollowDateTime: e.target.value }))}
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
                  />
                </div>
              )}
              <div>
                <label className="block text-[11px] font-semibold text-slate-600 mb-1">Call Notes</label>
                <textarea
                  rows="3"
                  placeholder="Add follow-up notes..."
                  value={form?.note || ''}
                  onChange={(e) => setForm((prev) => ({ ...prev, note: e.target.value }))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
                />
              </div>
            </div>
          )}

          </div>

          <div className="flex items-center justify-end gap-2 shrink-0 bg-white border-t border-slate-100 px-4 py-3">
            <button type="button" onClick={onClose} className="px-3 py-2 text-sm border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50">
              Cancel
            </button>
            <button type="submit" disabled={submitting} className="px-3 py-2 text-sm bg-[#009ef7] text-white rounded-lg disabled:opacity-60">
              {submitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CallFormModal;
